import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=c7912f20&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=c7912f20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports